export function selectors(): StoreTypes.Selector {
  return {}
}
